<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <div class="ibox">
                    <div class="ibox-content">
                        <vue-good-table :columns="columns" :rows="rows" row-style-class="fs-10px" v-if="rows != null"
                            styleClass="vgt-table condensed bordered">
                            <template slot="table-row" slot-scope="props">
                                <div style="width:100%; height:100%;" class="text-white p-1"
                                    v-if="props.column.field == 'collected'"
                                    :class="{ 'bg-limegreen': props.row.collected != null }">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                                <div style="width:100%; height:100%;" class="text-white p-1"
                                    v-else-if="props.column.field == 'checking'"
                                    :class="{ 'bg-limegreen-dark': props.row.checking != null }">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                                <div style="width:100%; height:100%;" class="text-white p-1"
                                    v-else-if="props.column.field == 'checked'"
                                    :class="{ 'bg-limegreen': props.row.checked != null }">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                                <span v-else-if="props.column.field == 'place_barcode'">
                                    <a href="" data-toggle="modal" data-target="#detailsModal" @click="selectPlace(props.row.place_barcode)">{{ props.row.place_barcode
                                    }}</a>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>
                        <div class="w-100 text-center" v-else>
                            <h5>Leltárasztal betöltése...</h5>
                            <i class="fa fa-cog fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="detailsModal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Tételek  {{ selected_place_barcode }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="w-100 text-center" v-if="!selected_place_data">
                            <i class="fa fa-cog fa-spin fa-2x"></i>
                        </div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table fs-10px">
                                    <thead>
                                        <tr class="table-dark">
                                            <th>típus</th>
                                            <th>bizonylatszám</th>
                                            <th>kezdés</th>
                                            <th>befejezés</th>
                                            <th>első tétel</th>
                                            <th>utolsó tétel</th>
                                            <th>mennyiség</th>
                                            <th>nMunkaidő</th>
                                            <th>nTempó</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(data_collection,id) in selected_place_data.data_collections" :key="id">
                                            <td>{{ data_collection.type }}</td>
                                            <td>{{ data_collection.receipt_number }}</td>
                                            <td>{{ data_collection.start }}</td>
                                            <td>{{ data_collection.end }}</td>
                                            <td>{{ data_collection.first_item }}</td>
                                            <td>{{ data_collection.last_item }}</td>
                                            <td>{{ data_collection.quantity }}</td>
                                            <td>{{ data_collection.working_time }}</td>
                                            <td>{{ data_collection.tempo }}</td>
                                        </tr>
                                        <tr v-if="selected_place_data.data_collections.length == 0">
                                            <td colspan="9">
                                                <div class="w-100 text-center">
                                                    <h5><i class="fa fa-times"></i></h5>
                                                    <h5>Nincs megjeleníthető adat</h5>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table-responsive">
                                <table class="table fs-10px">
                                    <thead>
                                        <tr class="table-dark">
                                            <th>bizonylat</th>
                                            <th>vonalkód</th>
                                            <th>cikkszám</th>
                                            <th>megnevezés</th>
                                            <th>egységár</th>
                                            <th>mennyiség</th>
                                            <th>érték</th>
                                            <th>egység</th>
                                            <th>lszsz</th>
                                            <th>szektor</th>
                                            <th>mde_date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,id) in selected_place_data.items" :key="id">
                                            <td>{{ item.receipt }}</td>
                                            <td>{{ item.barcode }}</td>
                                            <td>{{ item.article_number }}</td>
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.price }}</td>
                                            <td>{{ item.quantity }}</td>
                                            <td>{{ item.value }}</td>
                                            <td>{{ item.unit }}</td>
                                            <td>{{ item.lszsz }}</td>
                                            <td>{{ item.sector }}</td>
                                            <td>{{ item.mde_date }}</td>
                                        </tr>
                                        <tr v-if="selected_place_data.items.length == 0">
                                            <td colspan="11">
                                                <div class="w-100 text-center">
                                                    <h5><i class="fa fa-times"></i></h5>
                                                    <h5>Nincs megjeleníthető adat</h5>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import { VueGoodTable } from 'vue-good-table';
import appService from '../../apis/appService';

export default {
    components: {
        VueGoodTable,
    },
    data() {
        return {
            selected_place_barcode:null,
            selected_place_data:null,
            rows: null,
            columns: [
                {
                    label: 'Raktárhelyazonosító',
                    field: 'place_barcode',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Rögzítve',
                    field: 'collected',
                    thClass: 'fs-10px',
                    tdClass: 'p-0',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Ellenőrzésre',
                    field: 'checking',
                    thClass: 'fs-10px',
                    tdClass: 'p-0',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Ellenőrizve',
                    field: 'checked',
                    thClass: 'fs-10px',
                    tdClass: 'p-0',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'ismeretlen',
                    field: 'unknown',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Tempó',
                    field: 'tempo',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Szektor',
                    field: 'sector',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Korrekció',
                    field: 'correction',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
                {
                    label: 'Megjegyzés',
                    field: 'comment',
                    thClass: 'fs-10px',
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Keresés...'
                    }
                },
            ]
        }
    },
    computed: {
        lszsz() {
            return this.$store.state.lszsz;
        },
        online() {
            return this.$store.state.online;
        },
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        appService.getInventoryTable(this.user.project_id, this.lszsz, appService.getDeviceId()).then(response => {
            this.rows = response.data;
        })
        this.$store.commit('updateSubTitle', 'Leltárasztal');
    },
    methods:{
        selectPlace(barcode){
            this.selected_place_barcode = barcode;
            appService.getPlaceDetails(this.user.project_id,this.lszsz,appService.getDeviceId(),barcode).then(response => {
                this.selected_place_data = response.data;
            });
            /*this.selected_place_data = {
                data_collections: [
                    {type:'MDE',receipt_number:'0015',start:'2023-10-25 01:15:00',end:'2023-10-25 13:14:03',first_item:'2023-10-25 01:15:00',last_item:'2023-10-25 01:15:00',quantity:32,working_time:'707:05',tempo:4},
                    {type:'MDE',receipt_number:'0015',start:'2023-10-25 01:15:00',end:'2023-10-25 13:14:03',first_item:'2023-10-25 01:15:00',last_item:'2023-10-25 01:15:00',quantity:32,working_time:'707:05',tempo:4},
                    {type:'MDE',receipt_number:'0015',start:'2023-10-25 01:15:00',end:'2023-10-25 13:14:03',first_item:'2023-10-25 01:15:00',last_item:'2023-10-25 01:15:00',quantity:32,working_time:'707:05',tempo:4}
                ],
                items:[
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'},
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'},
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'},
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'},
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'},
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'},
                    {receipt:'0023',barcode:'0000000023',article_number:'765',name:'PIROS ALMA LÉDIG',price:988,amount:'10.000',value:'1 370',unit:'db',lszsz:166,sector:1232,mde_date:'2023-10-25 01:15:00'}
                ]
            };*/
        }
    }
}
</script>